export const FETCH_ERROR_HANDLER = 'FETCH_ERROR_HANDLER';

export const fetchErrorHandler = (error, message) => ({
  type: FETCH_ERROR_HANDLER,
  payload: {
    error,
    message,
  },
});
